import $api from '@/api'

interface IDiscuss {
  nickname: string
  content: string
}

// 添加一条用户留言
export const newDiscuss = (data: IDiscuss): any => {
  return $api.post('/discuss', data)
}

// 显示所有已通过审核的用户留言，每次8条，pageNumber代表页数
export const allDiscuss = (pageNumber: number): any => {
  return $api.get('/discuss', { pageNumber })
}
